import { router } from '@/router';
import { store } from '@/store';

export const handleUnauthorized = () => {
   // Unauthorized. Clear expired token if present
   store.commit('auth/logout');
   const current = router.currentRoute;
   if (!current.name || !current.meta || !current.meta.guest) {
      const redirect = {
         name: 'login',
         query: { redirect: current.path },
      };
      // noinspection JSIgnoredPromiseFromCall
      router.replace(redirect);
   }
};

export const handleAuthorized = () => {
   // Redirect if currently on login page
   const current = router.currentRoute;
   if (current.name === 'login' && current.query.redirect) {
      router.push(current.query.redirect);
   }
};
